export enum PersonTranslKey {
    ACTION_SUCCESSFULL = "person:actionSuccessful",
    ACTION_STILL_IN_PROGRESS = "person:actionStillInProgress",
    FORCE_SYNC_REZA_CONFIRM_BUTTON = "person:forceSyncRezaConfirmButton",
    FORCE_SYNC_REZA_CONFIRM_DIALOG_MESSAGE = "person:forceSyncRezaConfirmDialogText",
    FORCE_SYNC_REZA_CONFIRM_TITLE = "person:forceSyncRezaConfirmTitle",
    FORCE_SYNC_REZA_REQUESTED = "person:forceSyncRezaRequested",
    FORCE_SYNC_REZA_TOOLTIP = "person:forceSyncRezaTooltip",
    FORCE_SYNC_ROB_CONFIRM_BUTTON = "person:forceSyncRobConfirmButton",
    FORCE_SYNC_ROB_CONFIRM_DIALOG_MESSAGE = "person:forceSyncRobConfirmDialogText",
    FORCE_SYNC_ROB_CONFIRM_TITLE = "person:forceSyncRobConfirmTitle",
    FORCE_SYNC_ROB_REQUESTED = "person:forceSyncRobRequested",
    FORCE_SYNC_ROB_TOOLTIP = "person:forceSyncRobTooltip",
    PERSON_AGENDA_SUBSCRIPTION_STATUSES = "person:agendaSubscriptionStatuses",
    PERSON_DATA_ORIGIN = "person:dataOrigin",
    PERSON_DETAIL = "person:personDetail",
    PERSON_EMAIL = "person:personEmail",
    PERSON_FIRSTNAME = "person:personFirstname",
    PERSON_ISZR_UPDATED_AT = "person:iszrUpdatedAt",
    PERSON_LASTNAME = "person:personLastname",
    PERSON_OVERVIEW = "person:personOverview",
    PERSON_PHONE = "person:personPhone",
    PERSON_SUBSCRIPTION_STATUS = "person:subscriptionStatus",
    SUBSCRIBE_TO_UPDATES_FROM_CONFIRM_BUTTON = "person:subscribeToUpdatesFromIszrConfirmButton",
    SUBSCRIBE_TO_UPDATES_FROM_CONFIRM_DIALOG_MESSAGE = "person:subscribeToUpdatesFromIszrConfirmDialogText",
    SUBSCRIBE_TO_UPDATES_FROM_CONFIRM_TITLE = "person:subscribeToUpdatesFromIszrConfirmTitle",
    SUBSCRIBE_TO_UPDATES_FROM_ROB_REQUESTED = "person:subscribeToUpdatesFromIszrRequested",
    SUBSCRIBE_TO_UPDATES_FROM_ROB_TOOLTIP = "person:subscribeToUpdatesFromIszrTooltip",
    UNSUBSCRIBE_FROM_UPDATES_FROM_ISZR_CONFIRM_BUTTON = "person:unsubscribeFromUpdatesFromIszrConfirmButton",
    UNSUBSCRIBE_FROM_UPDATES_FROM_ISZR_CONFIRM_DIALOG_MESSAGE = "person:unsubscribeFromUpdatesFromIszrConfirmDialogText",
    UNSUBSCRIBE_FROM_UPDATES_FROM_ISZR_CONFIRM_TITLE = "person:unsubscribeFromUpdatesFromIszrConfirmTitle",
    UNSUBSCRIBE_FROM_UPDATES_FROM_ISZR_REQUESTED = "person:unsubscribeFromUpdatesFromIszrRequested",
    UNSUBSCRIBE_FROM_UPDATES_FROM_ISZR_TOOLTIP = "person:unsubscribeFromUpdatesFromIszrTooltip",
}
